import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

import "common/css/master.css";
import "./panel.css";
import { panelContentListSvc, addPanelContentSvc, setPanelContentTimeSvc } from './panelSvc';
import PanelContentTbl from './panelContentTbl';



function PanelContentSlider(props) {
    const { panelDtls, closeSlider, } = props

    const [editLoader, setEditLoader] = useState("none");
    const [editOpacity, setEditOpacity] = useState(1);
    const [panelId, setPanelId] = useState(0);
    const [panel, setPanel] = useState(0);
    const [lstContent, setLstContent] = useState([]);
    const [lstContentOrdered, setLstContentOrdered] = useState([]);
    const [lstContentId, setLstContentId] = useState([]);
    const [layoutTypeId, setLayoutTypeId] = useState(0);
    const [key, setKey] = useState(0);


    useEffect(() => {
        // console.log("PanelContentSlide called, panelDtls", panelDtls);
        setPanelId(panelDtls.panelId);
        setPanel(panelDtls.panel);
        setLayoutTypeId(panelDtls.layoutTypeId);
        if (!!panelDtls.panelId)
            getPanelContentList(panelDtls.panelId);
    }, [panelDtls, key]);


    const getPanelContentList = (pnlId) => {
        // console.log("getPanelContentList called, pnlId", pnlId);
        setEditLoader("block");
        setEditOpacity(0.5);
        panelContentListSvc(pnlId, panelContentListResponse);
    }


    const panelContentListResponse = (data) => {
        // console.log("panelContentListResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            setLstContent(data.lstContent);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }



    const setContentTime = async () => {
        // console.log("setContentTime called");
        // const displayTime = prompt("Please enter display time in seconds:");
        const { value: displayTime } = await Swal.fire({
            title: "Set Display Time",
            input: "number",
            inputLabel: "Enter display time in seconds",
            inputPlaceholder: "Enter time (e.g., 10)",
            showCancelButton: true,
            confirmButtonText: "Submit",
            cancelButtonText: "Cancel",
            inputValidator: (value) => {
                if (!value || value <= 0) {
                    return "Please enter a valid positive number!";
                }
            },
            customClass: {
                title: 'swal-title custom-swal-title',
                content: 'swal-text custom-swal-text',
                input: 'swal-input custom-swal-input',
                confirmButton: 'swal-confirm-button custom-swal-confirm',
                cancelButton: 'swal-cancel-button custom-swal-cancel',
                inputLabel: 'swal-input-label',  // Added custom class for input label

            }, // Button color
            inputAttributes: {
                style: 'font-size: 1.5rem;'
            },
            didOpen: () => {
                const swalPopup = document.querySelector('.swal2-popup');
                if (swalPopup) {
                    swalPopup.style.display = 'flex'; // Ensure it's a flex container
                    swalPopup.style.justifyContent = 'center'; // Center content vertically
                    swalPopup.style.alignItems = 'center'; // Center content horizontally
                    swalPopup.style.flexDirection = 'column'; // Stack elements vertically
                    swalPopup.style.position = 'fixed'; // Fix the modal to the screen
                    swalPopup.style.top = '44%';  // Adjust top value
                    swalPopup.style.left = '44%'; // Center horizontally with 50%
                    swalPopup.style.transform = 'translate(-50%, -50%)'; // Center the modal fully
                    swalPopup.style.width = 'auto'; // Allow auto width
                    swalPopup.style.maxWidth = '90%'; // Adjust for responsiveness
                }
            }
        });
        if (!displayTime) {
            toast.warn("please select display time for slideshow");
            return;
        }

        // console.log("lstContentId", lstContentId);
        // console.log("lstContentOrdered", lstContentOrdered);
        let tempLstContent = lstContentId.map(id => {
            const matchedContent = lstContentOrdered.find(content => content.contentId === id);
            return {
                contentId: id,
                displayOrder: matchedContent ? matchedContent.displayOrder + 1 : null,
                displayTm: displayTime ? displayTime : (matchedContent ? matchedContent.displayTm : null),
            };
        });
        tempLstContent.sort((a, b) => {
            const indexA = lstContentOrdered.findIndex(content => content.contentId === a.contentId);
            const indexB = lstContentOrdered.findIndex(content => content.contentId === b.contentId);
            return indexA - indexB;
        });
        const panelContentObj = {
            panelId,
            lstContent: tempLstContent,
        };
        // console.log("panelContentObj", panelContentObj);
        setPanelContentTimeSvc(panelContentObj, setContentTimeResponse);
    }

    const setContentTimeResponse = (data) => {
        // console.log("setContentTimeResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            updateKey();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }
    const assignContent = () => {
        // console.log("assignContent called");
        // console.log("lstContentId", lstContentId);
        // console.log("lstContentOrdered", lstContentOrdered);
        let tempLstContent = lstContentId.map(id => {
            const matchedContent = lstContentOrdered.find(content => content.contentId === id);
            return {
                contentId: id,
                displayOrder: matchedContent ? matchedContent.displayOrder + 1 : null,
                displayTm: matchedContent ? matchedContent.displayTm : null,
            };
        });
        tempLstContent.sort((a, b) => {
            const indexA = lstContentOrdered.findIndex(content => content.contentId === a.contentId);
            const indexB = lstContentOrdered.findIndex(content => content.contentId === b.contentId);
            return indexA - indexB;
        });
        const panelContentObj = {
            panelId,
            lstContent: tempLstContent,
        };
        // console.log("panelContentObj", panelContentObj);
        addPanelContentSvc(panelContentObj, assignContentResponse);
    };


    const assignContentResponse = (data) => {
        // console.log("assignContentResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            updateKey();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }


    const removeAssignContent = () => {
        // console.log("removeAssignContent called");
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const handleSelect = (contentId) => {
        // console.log("handleSelectCalled, contentId", contentId);
        const updatedLstContent = lstContentId.includes(contentId)
            ? lstContentId.filter((id) => id !== contentId)
            : [...lstContentId, contentId];
        setLstContentId(updatedLstContent);
    }
    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    }

    return (
        <div >
            <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove "
                style={{
                    cursor: (editLoader === "none") ? 'pointer' : 'none',
                    pointerEvents: (editLoader === "none") ? 'auto' : 'none',
                    opacity: editOpacity
                }}>
                <div className="col-sm-10 col-md-10 col-centered "
                    style={{
                        height: "90vh", width: '94%', margin: '3% ', background: '#fff',
                        border: '1px solid #ccc', borderRadius: 10
                    }}>
                    {/* <div className="col-sm-10 col-md-10 col-centered padding-remove" style={{ marginTop: "10px" }} > */}
                    <div className="col-sm-12 col-md-12 padding-remove"
                        style={{
                            background: "#f9f9f9", // Light grayish-white
                            padding: "20px",
                            borderRadius: "10px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            color: "#333",
                            marginTop: "5px"
                        }}
                    >
                        <div className="col-sm-4 col-md-4 padding-remove">
                            <div className="col-sm-6 col-md-6" style={{ marginTop: "7px" }}>
                                {panel}
                            </div>
                            <div className="col-sm-6 col-md-6" >
                                {layoutTypeId === 10}{layoutTypeId === 10 ? (
                                    <div className="card card-landscape"></div>
                                ) : layoutTypeId === 20 ? (
                                    <div className="card card-portrait"></div>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 padding-remove" style={{ marginTop: "5px" }}>
                        <div className=" col-md-5 col-sm-5 col-xs-8 pull-right padding-remove">
                            <div className="col-sm-4 col-md-4 padding-remove">
                                <button type="button" className="btn btn-info " onClick={() => setContentTime()} >Set Time</button>
                            </div>
                            <div className="col-sm-4 col-md-4 padding-remove">
                                <button type="button" className="btn btn-info " onClick={() => assignContent()} >Assign</button>
                            </div>
                            <div className="col-sm-4 col-md-4 padding-remove">
                                <button type="button" className="btn btn-info " onClick={() => removeAssignContent()} >Remove</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 padding-remove" style={{ marginTop: "5px" }}>
                        <PanelContentTbl
                            lstContent={lstContent}
                            lstContentId={lstContentId}
                            handleSelect={handleSelect}
                            layoutTypeId={layoutTypeId}
                            setLstContentOrdered={setLstContentOrdered}
                        />
                    </div>
                </div>
            </div>
        </div>
        // </div>
    )
}

export default PanelContentSlider


